import PropTypes from "prop-types";

const BtnSecondaryL = ({ buttonCTA, onClickLink, type }) => {
  return (
    <button
      className="btn-secondary-l text-base"
      onClick={onClickLink}
      type={type}
    >
      {buttonCTA}
    </button>
  );
};

BtnSecondaryL.propTypes = {
  buttonCTA: PropTypes.string.isRequired,
  onClickLink: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default BtnSecondaryL;
